window.onload = function() {
  
  runGTM()

};

function runGTM() {
  
  	/*** Buttons click ***/
	let buttons = document.querySelectorAll('.gtm-button')
    let links = document.querySelectorAll('.gtm-a')
    let signUpButtons = document.querySelectorAll('.gtm-signup')
    buttons.forEach(button => runGTMButtons(button))
    links.forEach(link => runGTMLinks(link))
    signUpButtons.forEach(signUpButton => runGTMSignUpButtons(signUpButton))
    
    
  	/*** Contact Form ***/
    if (document.querySelector('#contact_form')) {
      document.querySelector('#contact_form')?.addEventListener('submit', function() {
        pushGTM('contact-us-message-sent')
      })
    }
    
  	/*** Subscribe Buttons ***/
    let subsbcribeButtons = document.querySelectorAll('.gtm-subscribe-button')
    subsbcribeButtons.forEach(button => runGTMSubscribeButtons(button))
    
  	/*** PopUp Proceed to Checkout ***/
    let existCondition = setInterval(function() {
      if (document.querySelectorAll('#dynamic-checkout-cart ul li').length > 0) {
        clearInterval(existCondition);
        let options = document.querySelectorAll('#dynamic-checkout-cart ul li')
        options.forEach(option => runPopUpAddToCartButtons(option))
      }
    }, 100); // check every 100ms
  
  	/*** Search Bar ***/
  	let typed = false
    let searchBar = document.querySelector('input.search')
    if (searchBar) {
      searchBar.addEventListener('input', ()=> {
        if (!typed) {
          pushGTM('header-search')
          typed = true
        }
  	})
    }
    
    /*** Login Button ***/
  	let loginIconLink = document.querySelector('.block-account .icon-link')
    if (loginIconLink) {
      loginIconLink.addEventListener('click', function() {
        if (this.getAttribute('href') === '/account/login') {
          pushGTM('header-login')
        }
	  })
    }

  /*** Register Button ***/
  let registerBtn = document.querySelector('#register button')
  if (registerBtn) {
    registerBtn.addEventListener('click', function() {
      let registerPolicy = document.querySelector('#register-policy')
      if (registerPolicy && registerPolicy.checked) {
        pushGTM('rewards-complete-registration')
      }
	})
  }
  
    /*** Social Footer Buttons ***/
  	let socialInstagram = document.querySelector('footer .social-instagram')
    if (socialInstagram) {
      socialInstagram.addEventListener('click', function() {
        let pathArray = window.location.pathname.split('/')
        if (pathArray[1] === "") {
      		pushGTM('hp-footer-follow-social-ig')
        } else if (pathArray[pathArray.length - 2] === "blogs") {
        	pushGTM('blog-follow-social-ig')
        } else if (pathArray[pathArray.length - 2] === "pages" && pathArray[pathArray.length - 1] === "about-us") {
          	pushGTM('aboutus-follow-social-ig')
        }
	  })
    }
    let socialFacebook = document.querySelector('footer .social-facebook')
    if (socialFacebook) {
      socialFacebook.addEventListener('click', function() {
        let pathArray = window.location.pathname.split('/')
        if (pathArray[1] === "") {
      		pushGTM('hp-footer-follow-social-fb')
        } else if (pathArray[pathArray.length - 2] === "blogs") {
        	pushGTM('blog-follow-social-fb')
        } else if (pathArray[pathArray.length - 2] === "pages" && pathArray[pathArray.length - 1] === "about-us") {

          	pushGTM('aboutus-follow-social-fb')
        }
	  })
    }
    
    /*** Stamped Iframe ***/
    var checkExist = setInterval(function() {
       let stampedRewardsInit = document.querySelector('.stamped-rewards-init')
       let stampedIframe = stampedRewardsInit && stampedRewardsInit.querySelector('iframe')
       let stampedGtmLink = stampedIframe && stampedIframe.contentDocument && stampedIframe.contentDocument.querySelector('.gtm-a')
       let stampedGtmAnchor = stampedGtmLink && stampedGtmLink.closest('a')
       if (stampedGtmAnchor) {

          stampedGtmAnchor.addEventListener('click', function() {
            pushGTM('blog-signup-rewards')
          })
          clearInterval(checkExist);
       }
    }, 100);

	setTimeout(function(){ 
      if (checkExist) {
        clearInterval(checkExist)
      }
    }, 10000);
}	

function runPopUpAddToCartButtons(option) {
  const convCode = document.querySelector('.subscriptions-active') && document.querySelector('.subscription.selected') ? 'subscription' : 'product'
  let pathArray = window.location.pathname.split('/')
  
  option.addEventListener('click', function() {
      let optionDiv = this.querySelector('div')
      if (optionDiv && optionDiv.dataset.testid) {

        if (optionDiv.dataset.testid === 'ShopifyPay-button') {
          if (pathArray[pathArray.length - 2] === "products") {
            //pushGTM(`${pathArray[pathArray.length - 1]}-addtocart-page`, 'shop pay')
            dataLayer.push({"event": `${pathArray[pathArray.length - 1]}-addtocart-page-shop-pay`,
                 "convCode": convCode
                 })
          }
        } else if (optionDiv.dataset.testid === 'GooglePay-button') {
          if (pathArray[pathArray.length - 2] === "products") {
            //pushGTM(`${pathArray[pathArray.length - 1]}-addtocart-page`, 'gpay')
            dataLayer.push({"event": `${pathArray[pathArray.length - 1]}-addtocart-page-gpay`,
                 "convCode": convCode
                 })
          }	
        }
      } else if (this.querySelector('iframe')) {
        // No se puede con PayPal, no captura el click en el iframe
      	//console.log('ES PAYPAL')
      }
    })
  
}

function runGTMButtons(el) {
	let button = el.closest('.btn')
    button.addEventListener('click', function() {
    	pushGTM(el.id)
    })
}

function runGTMLinks(el) {
	let a = el.closest('a')
    a.addEventListener('click', function() {
      	
    	pushGTM(el.id)
    })
}

function runGTMSignUpButtons(el) {
  let pathArray = window.location.pathname.split('/')
    el.addEventListener('click', function() {
    	if (pathArray[1] === "") {
      		pushGTM('hp-signup')
      	} else if (pathArray[pathArray.length - 2] === "blogs") {
        	pushGTM('blog-signup')
      	} else if (pathArray[pathArray.length - 2] === "pages" && pathArray[pathArray.length - 1] === "about-us") {
          	pushGTM('aboutus-signup')
        }
    })
}

function runGTMSubscribeButtons(el) {
    
	let button = el.closest('.btn')
    
    button.addEventListener('click', function() {
      
      var pathArray = window.location.pathname.split('/')
      if (pathArray[1] === "") {
      	pushGTM('hp-subscribe-footer')
      }	else if (pathArray[pathArray.length - 2] === "products") {
        pushGTM(`product-${pathArray[pathArray.length - 1]}-subscribe-email`)
      } else if (pathArray[pathArray.length - 2] === "blogs") {
        pushGTM('blog-subscribe')
      } else if (pathArray[pathArray.length - 2] === "pages" && pathArray[pathArray.length - 1] === "about-us") {
        pushGTM('aboutus-subscribe')
      }
    })
}

function pushGTM(id, type = null) {
  if (type) {
    type = type.replace(/\s+/g, '-').toLowerCase()
    dataLayer.push({"event": id + '-' + type})
    
  } else {
  	dataLayer.push({"event": id})
  }
  
}

function pushGTMaddToCart(id, type = null, subs = null) {
  console.log(type)

  const convCode = subs ? 'subscription' : 'product'
  if (type) {
    type = type.replace(/\s+/g, '-').toLowerCase()
    //dataLayer.push({"event": id + '-' + type})

    dataLayer.push({"event": id,
                    "productName": type,
                    "convCode" : convCode
                  });
    
  } else {
  	dataLayer.push({"event": id,
                   "convCode" : convCode
                   })
  }
  
  let productNameEl = document.querySelector('.content-summary h1.product-name')
  if (productNameEl) {

  	let title = productNameEl.textContent

	ttq.track('AddToCart', {
    	content_id: title + ' ' + type,
		content_type: 'product',
	});
    
  }
  
}

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

waitForElm('.ocu-cta__buy').then((elm) => {
    elm.addEventListener('click', function() {
      pushGTM('add-special-offer')
    })
});

waitForElm('.addItemsAjax').then((elm) => {
  var pathArray = window.location.pathname.split('/')
  if (pathArray[1] === 'products') {
        elm.addEventListener('click', function() {
      pushGTM('full-bundle-addtocart')
    })
  }
});

function setDiscountStickyText() {
  if (document.querySelector('.forever-ideal-discount')) {
    //let discountText = document.querySelector('.forever-ideal-discount').textContent
    //let stickyDiscount = document.querySelector('#sticky-discount')
    //stickyDiscount.innerHTML = document.querySelector('.forever-ideal-discount').textContent
    
    
  }
}

waitForElm('.forever-ideal-discount .save-discount').then((elm) => {
    setTimeout(function() {setDiscountStickyText()}, 5000);
});

waitForElm('.template-product').then((elm) => {
 
    let viewContentProductNameEl = document.querySelector('.content-summary h1.product-name')
    if (viewContentProductNameEl) {
      let title = viewContentProductNameEl.textContent
      ttq.track('ViewContent', {
          content_id: title,
          content_type: 'product',
      });
    }
    
});

if (typeof OCUApi !== 'undefined') {
	OCUApi.onAccept = function(){
      pushGTM(`presell-accepted`)
    }
	OCUApi.onDecline = function(){
      pushGTM(`presell-declined`)
    }
  }
function pushGTMProceed() {
console.log('pushGTMProceed')
  var pathArray = window.location.pathname.split('/')
  pushGTM(`${pathArray[2]}-proceed-to-checkout`)
}

function pushGTMContinue() {
  const convCode = document.querySelector('.subscriptions-active') && document.querySelector('.subscription.selected') ? 'subscription' : 'product'
  var pathArray = window.location.pathname.split('/')
  //pushGTM(`${pathArray[2]}-continue-shopping`)
  dataLayer.push({"event": `${pathArray[2]}-continue-shopping`,
    "convCode": convCode
  })
}